/* CP — eigene Auswahllisten fuer Marke und Modell. Ausgelagert aus cp-category.js. */
/* CP Kategorieseite — eigene Auswahllisten für Marke und Modell.
   Das <select> bleibt als Datenhaltung erhalten (Formular, Events, Tastatur-Fallback);
   sichtbar ist eine Liste im CP-Design, die immer nach unten aufklappt. */
(function(){
  var OPEN = null;

  function boxOf(el){ return el.closest ? el.closest('.cpk__veh') : null; }

  function closeOpen(){
    if(!OPEN) return;
    OPEN.wrap.classList.remove('is-open');
    OPEN.btn.setAttribute('aria-expanded', 'false');
    OPEN.list.hidden = true;
    var box = boxOf(OPEN.wrap);
    if(box) box.classList.remove('is-cbxopen');
    OPEN = null;
  }

  function build(sel){
    if(!sel || sel.__cpkCbx) return;
    sel.__cpkCbx = true;

    var wrap = document.createElement('div');
    wrap.className = 'cpk__cbx';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cpk__cbxbtn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var lab = document.createElement('span');
    lab.className = 'cpk__cbxlabel';
    btn.appendChild(lab);
    var arr = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arr.setAttribute('viewBox', '0 0 24 24');
    arr.setAttribute('aria-hidden', 'true');
    var pth = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    pth.setAttribute('d', 'M6 9l6 6 6-6');
    arr.appendChild(pth);
    btn.appendChild(arr);
    var list = document.createElement('div');
    list.className = 'cpk__cbxlist';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    wrap.appendChild(btn);
    wrap.appendChild(list);

    var api = { wrap:wrap, btn:btn, list:list, sel:sel, lab:lab };
    sel.__cpk = api;

    btn.addEventListener('click', function(e){
      e.stopPropagation();
      if(sel.disabled) return;
      if(OPEN === api){ closeOpen(); return; }
      closeOpen();
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      list.hidden = false;
      list.scrollTop = 0;
      var box = boxOf(wrap);
      if(box) box.classList.add('is-cbxopen');
      OPEN = api;
      var on = list.querySelector('[aria-selected="true"]');
      if(on && on.scrollIntoView) on.scrollIntoView({ block:'nearest' });
    });

    btn.addEventListener('keydown', function(e){
      if(e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' '){
        if(list.hidden){ e.preventDefault(); btn.click(); }
      }
    });

    list.addEventListener('keydown', function(e){
      var opts = Array.prototype.slice.call(list.querySelectorAll('[role="option"]:not([disabled])'));
      var idx = opts.indexOf(document.activeElement);
      if(e.key === 'ArrowDown'){ e.preventDefault(); (opts[idx + 1] || opts[0]).focus(); }
      else if(e.key === 'ArrowUp'){ e.preventDefault(); (opts[idx - 1] || opts[opts.length - 1]).focus(); }
      else if(e.key === 'Escape'){ e.preventDefault(); closeOpen(); btn.focus(); }
      else if(e.key === 'Tab'){ closeOpen(); }
    });

    sel.addEventListener('change', function(){ sync(sel); });
    sync(sel);
  }

  function sync(sel){
    var api = sel.__cpk;
    if(!api) return;
    api.wrap.hidden = sel.hidden;
    api.wrap.classList.toggle('is-disabled', !!sel.disabled);
    api.btn.disabled = !!sel.disabled;

    var cur = sel.options[sel.selectedIndex];
    api.lab.textContent = cur ? cur.text : '';
    api.wrap.classList.toggle('is-empty', !sel.value);

    api.list.textContent = '';
    for(var i=0; i<sel.options.length; i++){
      var o = sel.options[i];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cpk__cbxopt';
      b.setAttribute('role', 'option');
      b.textContent = o.text;
      b.dataset.v = o.value;
      if(o.disabled) b.disabled = true;
      b.setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false');
      if(!o.value) b.classList.add('is-placeholder');
      b.addEventListener('click', function(e){
        e.stopPropagation();
        var v = this.dataset.v;
        closeOpen();
        if(sel.value === v){ api.btn.focus(); return; }
        sel.value = v;
        sel.dispatchEvent(new Event('change', { bubbles:true }));
        api.btn.focus();
      });
      api.list.appendChild(b);
    }
  }

  function scan(scope){
    var list = (scope || document).querySelectorAll('[data-cpk-brand],[data-cpk-model]');
    for(var i=0; i<list.length; i++){
      var sel = list[i];
      build(sel);
      if(!sel.__cpkObs && window.MutationObserver){
        sel.__cpkObs = new MutationObserver(function(recs){
          sync(recs[0].target);
        });
        sel.__cpkObs.observe(sel, { childList:true, attributes:true,
          attributeFilter:['hidden','disabled'] });
      }
    }
  }

  document.addEventListener('click', closeOpen);
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' || e.key === 'Esc') closeOpen();
  });

  scan(document);
  document.addEventListener('shopify:section:load', function(e){ scan(e.target); });
})();
